import React, { useContext } from 'react';
import { useIntl } from 'react-intl';

import { AppLocale, SHORT_BAND_NAME, SHORT_BAND_NAME_JP } from 'constant';

import { LanguageContext } from 'context/languageContext';

import Social from 'components/Social';
import BandMembersList from 'components/BandMembersList';

import ArrowLink from 'components/ui/ArrowLink';
import Title from 'components/ui/Title';
import SidebarBox from 'components/ui/SidebarBox';

import japanFlag from 'assets/jp.svg';
import usaFlag from 'assets/us.svg';

import {
  Wrapper,
  FlagBox
} from './AboutPageSideBar.styles';

const AboutPageSideBar = () => {
  const intl = useIntl();
  const { locale } = useContext(LanguageContext);

  return (
    <Wrapper>
      <SidebarBox>
        <Title size="big">
          {intl.formatMessage({ id: 'about.members.title' })}
        </Title>
        <BandMembersList smallerMargin />
      </SidebarBox>
      <SidebarBox>
        <Title size="big">
          {intl.formatMessage({ id: 'about.bandInfo' })}
        </Title>
        <table>
          <tbody>
          <tr>
            <td>{intl.formatMessage({ id: 'about.info.origin.title' })}</td>
            <td>{intl.formatMessage({ id: 'about.info.origin.description' })}</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'about.info.active.title' })}</td>
            <td>{intl.formatMessage({ id: 'about.info.active.description' })}</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'about.info.genres.title' })}</td>
            <td>{intl.formatMessage({ id: 'about.info.genres.description' })}</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'about.info.agency.title' })}</td>
            <td>{intl.formatMessage({ id: 'about.info.agency.description' })}</td>
          </tr>
          <tr>
            <td>{intl.formatMessage({ id: 'about.info.label.title' })}</td>
            <td>
              <FlagBox>
                <img src={japanFlag} alt="Japan Flag" />
                <span>{intl.formatMessage({ id: 'about.info.label.jp.description' })}</span>
              </FlagBox>
              <FlagBox>
                <img src={usaFlag} alt="Japan Flag" />
                <span>{intl.formatMessage({ id: 'about.info.label.us.description' })}</span>
              </FlagBox>
            </td>
          </tr>
          </tbody>
        </table>
      </SidebarBox>
      <SidebarBox>
        <ArrowLink to="/about/history">
          {intl.formatMessage({ id: 'about.history.title' })}
        </ArrowLink>
        <ArrowLink to="/about/awards">
          {intl.formatMessage({ id: 'about.awards.title' })}
        </ArrowLink>
      </SidebarBox>
      <SidebarBox>
        <Title element="h2">
          {intl.formatMessage({ id: 'sidebar.socials' }, {
            shortBandName: locale === AppLocale.EN ? SHORT_BAND_NAME : SHORT_BAND_NAME_JP
          })}
        </Title>
        <Social />
      </SidebarBox>
    </Wrapper>
  );
};

export default AboutPageSideBar;
